module.exports = __webpack_public_path__ + "img/gm.eb0c7cba.svg";